import { render } from "./BreadCrumbPanel.vue?vue&type=template&id=5b8cab08&scoped=true"
import script from "./BreadCrumbPanel.vue?vue&type=script&lang=js"
export * from "./BreadCrumbPanel.vue?vue&type=script&lang=js"

import "./BreadCrumbPanel.vue?vue&type=style&index=0&id=5b8cab08&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b8cab08"

export default script